import Header from "../components/ui/Header";
import Footer from "../components/ui/Footer";
import { Outlet } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import FloatingZaloButton from "../components/ui/FloatingZaloButton";
import { LayoutContext } from "../contexts/LayoutContext";
import { useState } from "react";

const MainLayout = () => {
  const [isFullWidth, setIsFullWidth] = useState(false);

  return (
    <LayoutContext.Provider value={{ isFullWidth, setIsFullWidth }}>
      <div className="flex flex-col min-h-screen bg-bg w-full">
        <Header />
        <main className={
          isFullWidth
            ? "pt-[73px] w-full min-h-[65vh]"
            : "pt-[73px] w-full max-w-5xl mx-auto py-5 min-h-[65vh]"
        }>
          <Outlet />
        </main>
        <Footer />
        <Toaster position="top-center" />
        <FloatingZaloButton />
      </div>
    </LayoutContext.Provider>
  );
};

export default MainLayout;
